// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_2PfgF"};